export const toPrice = (num: number | undefined | null) => {
  const safeNum = num ?? 0;
  if (Math.abs(safeNum) >= 1e9) return (safeNum / 1e9).toFixed(1) + 'B';
  if (Math.abs(safeNum) >= 1e6) return (safeNum / 1e6).toFixed(1) + 'M';
  if (Math.abs(safeNum) >= 1e3) return (safeNum / 1e3).toFixed(1) + 'K';
  return safeNum.toFixed(1);
};

export const toPriceMillions = (num: number | undefined | null) => {
  const safeNum = num ?? 0;
  const normalized = Math.abs(safeNum) >= 1e6 ? safeNum / 1e6 : safeNum;
  return `${normalized.toFixed(1)}m`;
};

export const toCurrencyPriceMillions = (num: number | undefined | null, sign = '£') =>
  `${sign}${toPriceMillions(num)}`;

export const formatAvgPoints = (points: number | undefined | null): string => {
  const safePoints = points ?? 0;
  return safePoints.toFixed(1);
};
